export const MachineTypes = [
  { id: "Wire", name: "Wire" },
  { id: "Drill", name: "Drill" },
];

export const TelemetryTypes = [
  { id: "Telemetry", name: "Telemetry" },
  { id: "WorkingStatus", name: "Working Status" },
  { id: "WorkingHours", name: "Working Hours" },
  { id: "WorkingMinutes", name: "Working Minutes" },
  { id: "WorkingArea", name: "Working Area" },
  { id: "NumberOfWorkSessions", name: "Number Of Work Sessions" },
  { id: "TotalConsumables", name: "Total Consumables" },
  { id: "ConsumableRef", name: "Consumable Ref" },
  { id: "TaskHours", name: "Task Hours" },
  { id: "TaskMinutes", name: "Task Minutes" },
  { id: "CutType", name: "Cut Type" },
  { id: "CutPosition", name: "Cut Position" },
  { id: "AutoPilot", name: "Auto Pilot" },
  { id: "TractionSpeed", name: "Traction Speed" },
  { id: "GSMType", name: "GSM Type" },
  { id: "GSMSignal", name: "GSM Signal" },
  { id: "GSMOperator", name: "GSM Operator" },
  { id: "Alarm", name: "Alarm" },
  { id: "Notification", name: "Notification" },
];

export const TelemetryDataTypes = [
  { id: "Double", name: "Double" },
  { id: "Boolean", name: "Boolean" },
  { id: "String", name: "String" },
];

export const GraphTypes = [
  { id: "Graph", name: "Graph" },
  { id: "LastValue", name: "Last Value" },
  { id: "History", name: "History" },
];
